import {
	type Accessor,
	createContext,
	type ParentComponent,
	useContext,
} from "solid-js";

/**
 * Whether clips rendered inside can be put on the clipboard. Only a page that
 * also shows a `ClipboardView` should enable it: anywhere else an added clip
 * would go somewhere the reader can't see.
 */
const OffersClipboardContext = createContext<Accessor<boolean>>(() => false);

export const OffersClipboardProvider: ParentComponent<{ enabled: boolean }> = (
	props,
) => (
	<OffersClipboardContext.Provider value={() => props.enabled}>
		{props.children}
	</OffersClipboardContext.Provider>
);

export const useOffersClipboard = (): Accessor<boolean> =>
	useContext(OffersClipboardContext);
